// Formatear la fecha
export function formatDate(date) {
  let sp = date.split("-");
  let day = sp[2];
  let month = sp[1];
  let anno = sp[0];
  return [day, month, anno].join("/");
}
